import { App } from "vue";
import PrimeVue from "primevue/config";
import Aura from '@primeuix/themes/aura';
import { definePreset } from "@primeuix/themes";
import ToastService from 'primevue/toastservice';

const CustomPreset = definePreset( Aura, {
    semantic: {
        primary: {
            50: '#EFFAF1',
            100: '#D9F2DB',
            200: '#B5E3BE',
            300: '#88CE9F',
            400: '#4CA973',
            500: '#329565',
            600: '#227755',
            700: '#1C5F4B',
            800: '#184E42',
            900: '#143D37',
            950: '#0B2322'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#FFFFFF',
                    50: '{neutral.50}',
                    100: '{neutral.100}',
                    200: '{neutral.200}',
                    300: '{neutral.300}',
                    400: '{neutral.400}',
                    500: '{neutral.500}',
                    600: '{neutral.600}',
                    700: '{neutral.700}',
                    800: '{neutral.800}',
                    900: '{neutral.900}',
                    950: '{neutral.950}'
                }
            },
            dark: {
                surface: {
                    0: '#FFFFFF',
                    50: '{neutral.50}',
                    100: '{neutral.100}',
                    200: '{neutral.200}',
                    300: '{neutral.300}',
                    400: '{neutral.400}',
                    500: '{neutral.500}',
                    600: '{neutral.600}',
                    700: '{neutral.700}',
                    800: '{neutral.800}',
                    900: '{neutral.900}',
                    950: '{neutral.950}'
                }
            }
        }
    },
    components: {
        card: {
            colorScheme: {
                dark: {
                    root: {
                        background: '{surface.800}',
                        color: 'var(--color-base-content)'
                    }
                },
                light: {
                    root: {
                        color: 'var(--color-base-content)'
                    }
                }
            }
        }
    }
} );

const CustomThemeOptions = {
    theme: {
        preset: CustomPreset,
        options: {
            darkModeSelector: '[data-theme="dark"]',
        }
    },
    pt: {
        drawer: {
            root: {
                class: 'lg:w-4/5 xl:w-3/4 bg-base-100 h-full flex flex-col relative shadow-lg transition-transform duration-300 pointer-events-auto'
            }
        }
    },
    ptOptions: {
        mergeSections: true,
        mergeProps: false
    }
};

export default ( app: App ) => {
    app.use( PrimeVue, CustomThemeOptions );
    app.use( ToastService );
};
